export const CREDIT_DEBIT_CARD = 'CREDIT_DEBIT_CARD';
export const TIGO_MONEY = 'TIGO_MONEY';
export const ACCOUNT = 'ACCOUNT';

export const PAYMENT_DETAIL_STORAGE = "payment_detail";


// WEBPACK FOOTER //
// ./src/components/PaymentWizard/paymentMethodConst.js